<template>
  <div>
    <el-dialog
      :title="AddForm.id ? '编辑' : '新增'"
      :visible.sync="AddVisible"
      width="80%"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="AddForm"
        ref="AddForm"
        label-width="160px"
        class="demo-AddForm"
        :rules="rules"
      >
        <el-form-item label="仓库名称" prop="name">
          <el-input v-model="AddForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="AddForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="月结卡号" prop="monthlyCust">
          <el-input v-model="AddForm.monthlyCust"></el-input>
        </el-form-item>

        <el-form-item label="仓库类型" prop="type">
          <el-radio-group v-model="AddForm.type">
            <el-radio :label="1">主仓库</el-radio>
            <el-radio :label="2">子仓库</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="仓库位置" prop="prov">
          <el-cascader
            style="width: 100%"
            v-model="AddForm.prov"
            :options="area"
            :props="{ value: 'name', label: 'name', children: 'area' }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="仓库详细地址" prop="address">
          <el-input v-model="AddForm.address"></el-input>
        </el-form-item>
        <el-form-item label="配送范围" prop="entrepot" v-if="AddForm.type == 2">
          <el-cascader
            v-model="AddForm.entrepot"
            collapse-tags
            style="width: 100%"
            :options="area"
            :props="props"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="AddSubmitForm('AddForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import area from "./area.json";
export default {
  components: {},
  data() {
    return {
      area,
      props: { multiple: true, value: "name", label: "name", children: "area" },
      AddVisible: false,
      AddForm: {
        prov: [],
        address: "",
        name: "",
        phone: "",
        monthlyCust: "",
      },
      rules: {
        type: [{ required: true, message: "请选择", trigger: "change" }],
        monthlyCust: [{ required: true, message: "请输入", trigger: "change" }],
        address: [{ required: true, message: "请输入", trigger: "change" }],
        phone: [{ required: true, message: "请输入", trigger: "change" }],
        name: [{ required: true, message: "请输入", trigger: "change" }],
        prov: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  created() {},
  methods: {
    init(row) {
      if (!row) {
        this.AddVisible = true;
        return false;
      }
      this.$axios
        .get("/admin/entrepot/getEntrepot?id=" + row.id, {})
        .then((res) => {
          res.data.prov = [res.data.province, res.data.city, res.data.county];
          res.data.entrepot = [];
          res.data.tentrepotAreas.forEach((el, index) => {
            res.data.entrepot[index] = [el.province, el.city, el.county];
          });
          this.$nextTick(() => {
            this.AddForm = {
              name: res.data.name,
              phone: res.data.phone,
              type: res.data.type,
              prov: res.data.prov,
              address: res.data.address,
              entrepot: res.data.entrepot,
              id: res.data.id,
              monthlyCust: res.data.monthlyCust,
            };
            this.AddVisible = true;
          });
        });
    },
    handleClose() {
      this.AddForm = {
        name: null,
        phone: null,
        type: null,
        prov: [],
        address: null,
        entrepot: [],
        monthlyCust: null,
      };
      this.$refs["AddForm"].resetFields();
      this.AddVisible = false;
    },
    AddSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.AddForm));
          obj.province = obj.prov[0];
          obj.city = obj.prov[1];
          obj.county = obj.prov[2];
          obj.entrepotAreaDtos = [];
          if (obj.type == 2) {
            obj.entrepot.forEach((el) => {
              obj.entrepotAreaDtos.push({
                province: el[0],
                city: el[1],
                county: el[2],
              });
            });
          }
          delete obj.prov;
          delete obj.entrepot;
          var ruleForm = {
            address: obj.address,
            city: obj.city,
            county: obj.county,
            name: obj.name,
            phone: obj.phone,
            province: obj.province,
            type: obj.type,
            monthlyCust: obj.monthlyCust,
            entrepotAreaDtos: obj.entrepotAreaDtos,
          };
          const loading = this.$loading({
            lock: true,
            text: "提交中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          if (obj.id) {
            ruleForm.id = obj.id;
            this.$axios
              .post("/admin/entrepot/editEntrepot", ruleForm)
              .then((res) => {
                loading.close();
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("AddForm");
                this.$emit("back");
              })
              .catch((err) => {
                loading.close();
              });
          } else {
            this.$axios
              .post("/admin/entrepot/addEntrepot", ruleForm)
              .then((res) => {
                loading.close();
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("AddForm");
                 this.$emit("back");
              })
              .catch((err) => {});
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
